import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";

import ResetPasswordForm from "../../Components/Forms/ResetPassword";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        zIndex: 1,
    },
});

const ResetPassword = () => {
    const classes = useStyles();
    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot}>
                <Box marginTop="64px" marginBottom="8px">
                    <Typography
                        variant="h2"
                        align="center"
                    >
						Reset your Password
                    </Typography>
                </Box>
                <ResetPasswordForm />
            </Card>
        </Container>
    );
};

export default ResetPassword;
